/**
 * Hostname helpers. During local dev we run on localhost and default to
 * the app (dashboard) surface unless VITE_FORCE_MARKETING is set.
 *
 * Production hosts are brand-pack driven so the same bundle can serve
 * okrapdf.com and parsegrid.ai.
 */
import { Effect } from 'effect';
import { isAppHostnameEffect, isMarketingHostnameEffect } from './brand';

export const isAppHostEffect = Effect.fn('web.host.isApp')(function* () {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  if (yield* isAppHostnameEffect(host)) return true;
  if (yield* isMarketingHostnameEffect(host)) return false;
  // Local dev / preview: default to app unless explicitly marketing
  return import.meta.env.VITE_FORCE_MARKETING !== 'true';
});

export function isAppHost(): boolean {
  return Effect.runSync(isAppHostEffect());
}

/**
 * Same-origin API base. In prod the SPA is served by the web Worker,
 * which rewrites `/api/okra/*` to the `agent-session` service binding
 * (see worker/index.ts). Dev hits api.okrapdf.com directly since no
 * Worker runs locally.
 *
 * `import.meta.env.PROD` is hard-coded by Vite at build time and can't
 * be overridden by .env.local (which otherwise shadows .env.production).
 */
export const API_ORIGIN = import.meta.env.PROD
  ? (typeof window !== 'undefined'
      ? `${window.location.origin}/api/okra`
      : 'https://api.okrapdf.com')
  : import.meta.env.VITE_API_ORIGIN || 'https://api.okrapdf.com';
